"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupsEligibilityService = void 0;
class GroupsEligibilityService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns the eligibility filters attached to that group by id.
     * @param id
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    getGroupEligibility(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/{id}/eligibility',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update the eligibility filters of a campaign group
     * @param id
     * @param requestBody
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    updateGroupEligibility(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/eligibility',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Check with creators elastic search the preview of the set that will be reached by this eligibility filters.
     * @param id
     * @param requestBody
     * @returns CampaignGroupEligibilityPreviewResponse
     * @throws ApiError
     */
    getGroupEligibilityPreview(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/eligibility/preview',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Enable the eligibility filters of a campaign group
     * @param id
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    enableGroupEligibility(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/eligibility/enable',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Disable the eligibility filters of a campaign group
     * @param id
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    disableGroupEligibility(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/{id}/eligibility/disable',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Generate multiple groups preview
     * @param requestBody
     * @returns CampaignGroupEligibilityPreviewResponse
     * @throws ApiError
     */
    getEligibilityPreviewOnMultipleGroups(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/groups/eligibility/generate-multiple-preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get daily eligible creators stats
     * @param requestBody
     * @returns DailyCreatorEligibilityResponse
     * @throws ApiError
     */
    getDailyEligibleCreatorsStats(requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/groups/eligibility/stats/daily-eligible-creators',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.GroupsEligibilityService = GroupsEligibilityService;
